<div>
  <div class="relative z-50 lg:hidden" role="dialog" aria-modal="true">
    <div
      class="fixed inset-0 bg-gray-900/80"
      [@offCanvasBackdropAnimation]="menuState"
      [ngClass]="menuState === 'hidden' ? 'hidden' : ''"
    ></div>

    <div class="fixed inset-0 flex" [@offCanvasMenuAnimation]="menuState">
      <div
        class="relative mr-16 flex w-full max-w-xs flex-1"
        [@offCanvasMenuAnimation]="menuState"
      >
        <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
          <button
            type="button"
            class="-m-2.5 p-2.5"
            (click)="toggleSidebarMenu()"
            [@closeButtonAnimation]="buttonState"
          >
            <span class="sr-only">Close sidebar</span>
            <svg
              class="h-6 w-6 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <!-- START-  Mobile menu -->
        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <div
          [@offCanvasMenuAnimation]="menuState"
          class="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4"
        >
          <div class="flex h-16 shrink-0 items-center">
            <img
              class="h-8 w-auto"
              src="assets/images/mango-logo--tinified.png"
              alt="Mango Asset Management Logo"
            />
          </div>
          <nav class="flex flex-1 flex-col">
            <ul role="list" class="flex flex-1 flex-col gap-y-7">
              <li>
                <ul role="list" class="-mx-2 space-y-1">
                  <li>
                    <a
                      routerLink="/admin/home"
                      routerLinkActive="bg-mango-lightOrange text-mango "
                      class="group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      <img
                        src="assets/images/svgs/statistics-chart--duotone.svg"
                        alt=""
                      />
                      Dashboard
                    </a>
                  </li>

                  <!-- Products dropdown - mobile -->
                  <li
                    *appHasPermission="[
                      'get_mutual_fund_products',
                      'get_fixed_deposit_product',
                      'get_tbill_products',
                      'get_bond_products',
                      'get_commercial_paper',
                      'get_pms_products',
                      'get_savings_products',
                    ]"
                  >
                    <a
                      (click)="toggleProductsDropdown()"
                      class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      <img src="assets/images/svgs/box--duotone.svg" alt="" />
                      Products

                      <img
                        [ngClass]="{
                          'rotate-180': productMenuState === 'hidden',
                        }"
                        class="dropdown--toggle-icon rotate-180"
                        src="assets/images/svgs/chevron-up.svg"
                        alt=""
                      />
                    </a>
                  </li>

                  <!-- Products dropdown menu items - mobile -->
                  <div
                    class="dropdown__wrapper"
                    [ngClass]="
                      productMenuState === 'visible' ? 'menu-open' : ''
                    "
                  >
                    <div>
                      <li *appHasPermission="'get_mutual_fund_products'">
                        <a
                          routerLink="/admin/mfd"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Mutual Funds
                        </a>
                      </li>
                      <li
                        *appHasPermission="[
                          'get_fixed_deposit_product',
                          'get_tbill_products',
                          'get_bond_products',
                          'get_commercial_paper',
                        ]"
                      >
                        <a
                          routerLink="/admin/lcm"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          LCM
                        </a>
                      </li>

                      <li *appHasPermission="'get_pms_products'">
                        <a
                          routerLink="/admin/pms"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          PMS
                        </a>
                      </li>

                      <li *appHasPermission="'get_savings_products'">
                        <a
                          routerLink="/admin/savings"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Savings
                        </a>
                      </li>
                    </div>
                  </div>

                  <!-- Accounts dropdown - mobile -->
                  <li
                    *appHasPermission="[
                      'get_account_list',
                      'can_view_account_meta',
                      'get_document_meta_data',
                      'get_kyc_document_list',
                      'get_update_details',
                      'get_all_account_with_rm_info',
                      'get_relationship_manager',
                      'get_relationship_managers_metadata',
                      'can_get_face_recognition_log',
                    ]"
                  >
                    <a
                      (click)="toggleAccountsDropdown()"
                      class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      <img src="assets/images/svgs/box--duotone.svg" alt="" />
                      Accounts

                      <img
                        [ngClass]="{
                          'rotate-180': accountMenuState === 'hidden',
                        }"
                        class="dropdown--toggle-icon rotate-180"
                        src="assets/images/svgs/chevron-up.svg"
                        alt=""
                      />
                    </a>
                  </li>

                  <!-- Accounts dropdown menu items - mobile -->
                  <div
                    class="dropdown__wrapper"
                    [ngClass]="
                      accountMenuState === 'visible' ? 'menu-open' : ''
                    "
                  >
                    <div>
                      <li
                        *appHasPermission="[
                          'get_account_list',
                          'can_view_account_meta',
                        ]"
                      >
                        <a
                          routerLink="/admin/accounts"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Account List
                        </a>
                      </li>

                      <li
                        *appHasPermission="[
                          'get_document_meta_data',
                          'get_kyc_document_list',
                          'get_update_details',
                        ]"
                      >
                        <a
                          routerLink="/admin/approvals"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Approvals
                        </a>
                      </li>
                      <li
                        *appHasPermission="[
                          'get_all_account_with_rm_info',
                          'get_relationship_manager',
                          'get_relationship_managers_metadata',
                        ]"
                      >
                      <div
                        class="flex flex-1 items-center hover:bg-gray-50 rounded-md"
                        routerLinkActive="bg-mango-lightOrange text-mango"
                        #rla="routerLinkActive"
                      >
                        <a
                          routerLink="/admin/accountrm"
                          class="relative group flex gap-x-3 rounded-md p-2 pl-11 pr-8 text-sm font-semibold leading-6"
                        >
                          Relationship Managers
                          @if (accountMetadata$ | async; as metadata) {
                            @if (metadata?.account_without_rm && metadata.account_without_rm > 0) {
                              <app-count-badge 
                                [count]="metadata.account_without_rm">
                              </app-count-badge>
                            }
                          }
                        </a>
                      </div>
                      </li>
                      <li
                        *appHasPermission="'can_get_face_recognition_log'"
                      >
                        <a
                          routerLink="/admin/facial-recognition-log"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Facial Recognition Log
                        </a>
                      </li>
                    </div>
                  </div>

                  <!-- Users dropdown - mobile -->
                  <li
                    *appHasPermission="[
                      'get_permission',
                      'get_roles',
                      'view_profile_list',
                      'get_all_identity_records',
                      'view_admin_list',
                      'get_all_audit_log',
                      'can_get_partner',
                    ]"
                  >
                    <a
                      (click)="toggleUsersDropdown()"
                      class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      <img
                        src="assets/images/svgs/users-group--duotone.svg"
                        alt=""
                      />
                      Users

                      <img
                        [ngClass]="{ 'rotate-180': userMenuState === 'hidden' }"
                        class="dropdown--toggle-icon rotate-180"
                        src="assets/images/svgs/chevron-up.svg"
                        alt=""
                      />
                    </a>
                  </li>

                  <!-- Users dropdown menu items - mobile -->
                  <div
                    class="dropdown__wrapper"
                    [ngClass]="userMenuState === 'visible' ? 'menu-open' : ''"
                  >
                    <div>
                      <li *appHasPermission="'view_profile_list'">
                        <a
                          routerLink="/admin/customers"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Mobile App Users
                        </a>
                      </li>

                      <li *appHasPermission="'view_admin_list'">
                        <a
                          routerLink="/admin/users"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          System Users
                        </a>
                      </li>
                      <li *appHasPermission="'get_all_identity_records'">
                        <a
                          routerLink="/admin/identity-log"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Identity Log
                        </a>
                      </li>
                      <li *appHasPermission="'get_all_audit_log'">
                        <a
                          routerLink="/admin/audit-log"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Audit Log
                        </a>
                      </li>
                      <li *appHasPermission="'can_get_partner'">
                        <a
                          routerLink="/admin/partners"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Partners
                        </a>
                      </li>
                      <li *appHasPermission="['get_permission', 'get_roles']">
                        <a
                          routerLink="/admin/roles"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Roles
                        </a>
                      </li>
                    </div>
                  </div>
                  <!-- START OF REPORT -->
                  <li
                    class="cursor-not-allowed"
                    *appHasPermission="[
                      'can_get_account_with_fund',
                      'can_get_active_and_inactive_clients_report',
                      'can_get_global_portfolio_balance',
                      'get_account_list',
                      'get_mfd_report_records',
                    ]"
                  >
                    <a
                      routerLink="/admin/reports"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      <img
                        src="assets/images/svgs/document-report.svg"
                        alt=""
                      />
                      Reports
                    </a>
                  </li>
                  <!-- END OF REPORT -->

                  <!-- START - updated orders dropdown-->
                  <li
                    *appHasPermission="[
                      'get_all_order',
                      'order_meta_data',
                      'can_get_all_mfd_trx_request',
                    ]"
                  >
                    <a
                      (click)="toggleOrdersDropdown()"
                      class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      <img
                        src="assets/images/svgs/clipboard--duotone.svg"
                        alt=""
                      />
                      Orders

                      <img
                        [ngClass]="{
                          'rotate-180': ordersMenuState === 'hidden',
                        }"
                        class="dropdown--toggle-icon rotate-180"
                        src="assets/images/svgs/chevron-up.svg"
                        alt=""
                      />
                    </a>
                  </li>
                  <!-- Orders dropdown menu items - mobile -->
                  <div
                    class="dropdown__wrapper"
                    [ngClass]="ordersMenuState === 'visible' ? 'menu-open' : ''"
                  >
                    <div>
                      <li
                        *appHasPermission="[
                          'get_all_order',
                          'order_meta_data',
                          'can_get_all_mfd_trx_request',
                        ]"
                      >
                        <a
                          routerLink="/admin/orders"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Customer Orders
                        </a>
                      </li>
                      <li *appHasPermission="'can_get_all_mfd_trx_request'">
                        <a
                          routerLink="/admin/order-approvals"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Approvals
                        </a>
                      </li>
                    </div>
                  </div>
                  <!-- END - updated orders -->

                  <!-- START - referrals -->
                  <li
                    *appHasPermission="[
                      'get_referral_metadata',
                      'get_all_referrals_with_count',
                    ]"
                  >
                    <a
                      routerLink="/admin/referrals"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      <img
                        src="assets/images/svgs/users-group--duotone.svg"
                        alt=""
                      />
                      Referrals
                    </a>
                  </li>
                  <!-- END - referrals -->

                  <!-- START - transactions -->
                  <li
                    *appHasPermission="[
                      'get_wallet_transaction',
                      'can_view_settlement_account_balance',
                      'get_optimus_account_balance',
                      'can_get_global_portfolio_cash_balance',
                      'can_get_global_wallet_balance',
                      'can_view_cash_withdrawal_requests',
                      'can_view_global_principal',
                      'can_view_mutual_funds_list',
                      'can_get_all_funds_transaction',
                      'can_get_dividends',
                      'can_get_settlement_transactions'
                    ]"
                  >
                    <a
                      (click)="toggleTransactionsDropdown()"
                      class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      <img
                        src="assets/images/svgs/transfer-arrow--duotone.svg"
                        alt=""
                      />
                      Transactions

                      <img
                        [ngClass]="{
                          'rotate-180': transactionsMenuState === 'hidden',
                        }"
                        class="dropdown--toggle-icon rotate-180"
                        src="assets/images/svgs/chevron-up.svg"
                        alt=""
                      />
                    </a>
                  </li>

                  <!-- Transactions dropdown menu items - mobile -->
                  <div
                    class="dropdown__wrapper"
                    [ngClass]="
                      transactionsMenuState === 'visible' ? 'menu-open' : ''
                    "
                  >
                    <div>
                      <li
                        *appHasPermission="[
                          'get_wallet_transaction',
                          'can_view_settlement_account_balance',
                          'get_optimus_account_balance',
                        ]"
                      >
                        <a
                          routerLink="/admin/transactions/wallet"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Wallet Transactions
                        </a>
                      </li>

                      <li
                        *appHasPermission="[
                          'can_get_global_portfolio_cash_balance',
                          'can_get_global_wallet_balance',
                          'can_view_cash_withdrawal_requests',
                        ]"
                      >
                        <a
                          routerLink="/admin/transactions/cash"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Cash To Wallet
                        </a>
                      </li>
                      <li
                        *appHasPermission="[
                          'can_view_global_principal',
                          'can_view_mutual_funds_list',
                          'can_get_all_funds_transaction',
                          'can_get_dividends',
                        ]"
                      >
                        <a
                          routerLink="/admin/transactions/mutual-funds"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Mutual Funds
                        </a>
                      </li>

                      <li
                        *appHasPermission="[
                          'can_get_fx_transactions',
                          'can_get_fx_transactions_metadata',
                        ]"
                      >
                        <a
                          routerLink="/admin/transactions/fx"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          FX Transactions
                        </a>
                      </li>

                      <li
                        *appHasPermission="['can_get_settlement_transactions', 'can_get_settlement_metadata']"
                      >
                        <a
                          routerLink="/admin/transactions/settlement"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Transaction Settlement
                        </a>
                      </li>

                      <li *appHasPermission="'can_get_wallet_withdrawal_requests'">
                        <a
                          routerLink="/admin/transactions/withdrawal-requests"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Withdrawal Requests
                        </a>
                      </li>
                    </div>
                  </div>

                  <!-- END - transactions -->
                  <!-- Start- Notifications -->
                  <li>
                    <a
                      (click)="toggleNotificationsDropdown()"
                      class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="size-6"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97ZM6.75 8.25a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H7.5Z"
                          clip-rule="evenodd"
                        />
                      </svg>

                      Notifications

                      <img
                        [ngClass]="{
                          'rotate-180': notificationsMenuState === 'hidden',
                        }"
                        class="dropdown--toggle-icon rotate-180"
                        src="assets/images/svgs/chevron-up.svg"
                        alt=""
                      />
                    </a>
                  </li>

                  <!-- START - Notification dropdown menu items -->
                  <div
                    class="dropdown__wrapper"
                    [ngClass]="
                      notificationsMenuState === 'visible' ? 'menu-open' : ''
                    "
                  >
                    <div>
                      <li>
                        <a
                          *appHasPermission="'send_broadcast_message'"
                          routerLink="/admin/push-notifications"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Push Notifications
                        </a>
                      </li>

                      <li>
                        <a
                          routerLink="/admin/notification-logs"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Notification Logs
                        </a>
                      </li>
                    </div>
                  </div>
                  <!-- End: Notifications -->
                  <li *appHasPermission="['get_all_configs']">
                    <a
                      (click)="toggleSettingsDropdown()"
                      class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      <img
                        src="assets/images/svgs/settings--duotone.svg"
                        alt=""
                      />
                      Settings
                      <img
                        [ngClass]="{
                          'rotate-180': settingsMenuState === 'hidden'
                        }"
                        class="dropdown--toggle-icon rotate-180"
                        src="assets/images/svgs/chevron-up.svg"
                        alt=""
                      />
                    </a>
                  </li>

                  <!-- Settings dropdown menu items - mobile -->
                  <div
                    class="dropdown__wrapper"
                    [ngClass]="
                      settingsMenuState === 'visible' ? 'menu-open' : ''
                    "
                  >
                    <div>
                      <li *appHasPermission="['get_all_configs']">
                        <a
                          routerLink="/admin/settings/config"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Config
                        </a>
                      </li>
                      <li *appHasPermission="['get_all_configs']">
                        <a
                          routerLink="/admin/settings/bank"
                          routerLinkActive="bg-mango-lightOrange text-mango"
                          class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                        >
                          Bank Settings
                        </a>
                      </li>
                    </div>
                  </div>
                </ul>
              </li>

              <li class="mt-auto">
                <img
                  class="dashboard-svg"
                  src="assets/images/svgs/dashboard-side-illustration.svg"
                  alt=""
                />
              </li>
            </ul>
          </nav>
        </div>
        <!-- END  Mobile menu -->
      </div>
    </div>
  </div>

  <!-- START - Static sidebar for Desktop -->
  <div class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
    <!-- Sidebar component, swap this element with another sidebar if you like -->
    <div
      class="flex grow flex-col gap-y-5 overflow-y-auto border-gray-200 bg-white px-6 pb-4 pt-4"
    >
      <div class="flex h-16 shrink-0 items-center">
        <img
          class="h-8 w-auto"
          src="assets/images/mango-logo--tinified.png"
          alt="Mango Asset Management Logo"
        />
      </div>
      <nav class="flex flex-1 flex-col">
        <ul role="list" class="flex flex-1 flex-col gap-y-7">
          <li>
            <ul role="list" class="-mx-2 space-y-1">
              <li class="cursor-not-allowed">
                <a
                  routerLink="/admin/home"
                  routerLinkActive="bg-mango-lightOrange text-mango"
                  class="group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                >
                  <img
                    src="assets/images/svgs/statistics-chart--duotone.svg"
                    alt=""
                  />
                  Dashboard
                </a>
              </li>

              <!-- Products Dropdown - desktop -->
              <li
                *appHasPermission="[
                  'get_mutual_fund_products',
                  'get_fixed_deposit_product',
                  'get_tbill_products',
                  'get_bond_products',
                  'get_commercial_paper',
                  'get_pms_products',
                  'get_savings_products',
                ]"
              >
                <a
                  (click)="toggleProductsDropdown()"
                  class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                >
                  <img src="assets/images/svgs/box--duotone.svg" alt="" />
                  Products

                  <img
                    [ngClass]="{ 'rotate-180': productMenuState === 'hidden' }"
                    class="dropdown--toggle-icon rotate-180"
                    src="assets/images/svgs/chevron-up.svg"
                    alt=""
                  />
                </a>
              </li>
              <!-- Products dropdown menu items -->
              <div
                class="dropdown__wrapper"
                [ngClass]="productMenuState === 'visible' ? 'menu-open' : ''"
              >
                <div>
                  <li *appHasPermission="'get_mutual_fund_products'">
                    <a
                      routerLink="/admin/mfd"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Mutual Funds
                    </a>
                  </li>
                  <li
                    *appHasPermission="[
                      'get_fixed_deposit_product',
                      'get_tbill_products',
                      'get_bond_products',
                      'get_commercial_paper',
                    ]"
                  >
                    <a
                      routerLink="/admin/lcm"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      LCM
                    </a>
                  </li>

                  <li *appHasPermission="'get_pms_products'">
                    <a
                      routerLink="/admin/pms"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      PMS
                    </a>
                  </li>

                  <li *appHasPermission="'get_savings_products'">
                    <a
                      routerLink="/admin/savings"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Savings
                    </a>
                  </li>
                </div>
              </div>

              <!-- separator -->

              <!-- Accounts Dropdown -->
              <li
                *appHasPermission="[
                  'get_account_list',
                  'can_view_account_meta',
                  'get_document_meta_data',
                  'get_kyc_document_list',
                  'get_update_details',
                  'get_all_account_with_rm_info',
                  'get_relationship_manager',
                  'get_relationship_managers_metadata',
                  'can_get_face_recognition_log',
                ]"
              >
                <a
                  (click)="toggleAccountsDropdown()"
                  class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                >
                  <img src="assets/images/svgs/box--duotone.svg" alt="" />
                  Accounts

                  <img
                    [ngClass]="{ 'rotate-180': accountMenuState === 'hidden' }"
                    class="dropdown--toggle-icon rotate-180"
                    src="assets/images/svgs/chevron-up.svg"
                    alt=""
                  />
                </a>
              </li>
              <!-- Accounts dropdown menu items -->
              <div
                class="dropdown__wrapper"
                [ngClass]="accountMenuState === 'visible' ? 'menu-open' : ''"
              >
                <div>
                  <li
                    *appHasPermission="[
                      'get_account_list',
                      'can_view_account_meta',
                    ]"
                  >
                    <a
                      routerLink="/admin/accounts"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Account List
                    </a>
                  </li>

                  <li
                    *appHasPermission="[
                      'get_document_meta_data',
                      'get_kyc_document_list',
                      'get_update_details',
                    ]"
                  >
                    <a
                      routerLink="/admin/approvals"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Approvals
                    </a>
                  </li>
                  <li
                    *appHasPermission="[
                      'get_all_account_with_rm_info',
                      'get_relationship_manager',
                      'get_relationship_managers_metadata',
                    ]"
                  >
                     <div 
                      class="flex flex-1 items-center hover:bg-gray-50 rounded-md" 
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      #rla="routerLinkActive"
                    >
                      <a
                        routerLink="/admin/accountrm"
                        class="relative group flex gap-x-3 rounded-md p-2 pl-11 pr-8 text-sm font-semibold leading-6"
                      >
                        Relationship Managers
                        @if (accountMetadata$ | async; as metadata) {
                          @if (metadata?.account_without_rm && metadata.account_without_rm > 0) {
                            <app-count-badge 
                              [count]="metadata.account_without_rm">
                            </app-count-badge>
                          }
                        }
                      </a>
                    </div>
                  </li>
                  <li
                    *appHasPermission="'can_get_face_recognition_log'"
                  >
                    <a
                      routerLink="/admin/facial-recognition-log"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Facial Recognition Log
                    </a>
                  </li>
                </div>
              </div>

              <!-- Users dropdown -->
              <li
                *appHasPermission="[
                  'get_permission',
                  'get_roles',
                  'view_profile_list',
                  'get_all_identity_records',
                  'view_admin_list',
                  'get_all_audit_log',
                  'can_get_partner',
                ]"
              >
                <a
                  (click)="toggleUsersDropdown()"
                  class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                >
                  <img
                    src="assets/images/svgs/users-group--duotone.svg"
                    alt=""
                  />
                  Users

                  <img
                    [ngClass]="{ 'rotate-180': userMenuState === 'hidden' }"
                    class="dropdown--toggle-icon rotate-180"
                    src="assets/images/svgs/chevron-up.svg"
                    alt=""
                  />
                </a>
              </li>
              <!-- Users dropdown menu items -->
              <div
                class="dropdown__wrapper"
                [ngClass]="userMenuState === 'visible' ? 'menu-open' : ''"
              >
                <div>
                  <li *appHasPermission="'view_profile_list'">
                    <a
                      routerLink="/admin/customers"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Mobile App Users
                    </a>
                  </li>

                  <li *appHasPermission="'view_admin_list'">
                    <a
                      routerLink="/admin/users"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      System Users
                    </a>
                  </li>
                  <li *appHasPermission="'get_all_identity_records'">
                    <a
                      routerLink="/admin/identity-log"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Identity Log
                    </a>
                  </li>
                  <li *appHasPermission="'get_all_audit_log'">
                    <a
                      routerLink="/admin/audit-log"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Audit Log
                    </a>
                  </li>
                  <li *appHasPermission="'can_get_partner'">
                    <a
                      routerLink="/admin/partners"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Partners
                    </a>
                  </li>
                  <li *appHasPermission="['get_permission', 'get_roles']">
                    <a
                      routerLink="/admin/roles"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Roles
                    </a>
                  </li>
                </div>
              </div>
              <!-- REPORT -->
              <li
                class="cursor-not-allowed"
                *appHasPermission="[
                  'can_get_account_with_fund',
                  'can_get_active_and_inactive_clients_report',
                  'can_get_global_portfolio_balance',
                  'get_account_list',
                  'get_mfd_report_records',
                ]"
              >
                <a
                  routerLink="/admin/reports"
                  routerLinkActive="bg-mango-lightOrange text-mango"
                  class="group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                >
                  <img src="assets/images/svgs/document-report.svg" alt="" />
                  Reports
                </a>
              </li>
              <!-- END OF REPORT  -->

              <!-- START Orders dropdown -->
              <li
                *appHasPermission="[
                  'get_all_order',
                  'order_meta_data',
                  'can_get_all_mfd_trx_request',
                ]"
              >
                <a
                  (click)="toggleOrdersDropdown()"
                  class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                >
                  <img src="assets/images/svgs/clipboard--duotone.svg" alt="" />
                  Orders

                  <img
                    [ngClass]="{ 'rotate-180': ordersMenuState === 'hidden' }"
                    class="dropdown--toggle-icon rotate-180"
                    src="assets/images/svgs/chevron-up.svg"
                    alt=""
                  />
                </a>
              </li>
              <!-- Orders dropdown menu items - mobile -->
              <div
                class="dropdown__wrapper"
                [ngClass]="ordersMenuState === 'visible' ? 'menu-open' : ''"
              >
                <div>
                  <li
                    *appHasPermission="[
                      'get_all_order',
                      'order_meta_data',
                      'can_get_all_mfd_trx_request',
                    ]"
                  >
                    <a
                      routerLink="/admin/orders"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Customer Orders
                    </a>
                  </li>
                  <li *appHasPermission="'can_get_all_mfd_trx_request'">
                    <a
                      routerLink="/admin/order-approvals"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Approvals
                    </a>
                  </li>
                </div>
              </div>

              <!-- END - Orders -->
              <!-- START - Referrals -->
              <li
                class="cursor-not-allowed"
                *appHasPermission="[
                  'get_referral_metadata',
                  'get_all_referrals_with_count',
                ]"
              >
                <a
                  routerLink="/admin/referrals"
                  routerLinkActive="bg-mango-lightOrange text-mango"
                  class="group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                >
                  <img
                    src="assets/images/svgs/users-group--duotone.svg"
                    alt=""
                  />
                  Referrals
                </a>
              </li>
              <!-- END - Referrals -->

              <!-- START - Transactions -->
              <li
                *appHasPermission="[
                  'get_wallet_transaction',
                  'can_view_settlement_account_balance',
                  'get_optimus_account_balance',
                  'can_get_global_portfolio_cash_balance',
                  'can_get_global_wallet_balance',
                  'can_view_cash_withdrawal_requests',
                  'can_view_global_principal',
                  'can_view_mutual_funds_list',
                  'can_get_all_funds_transaction',
                  'can_get_dividends',
                  'can_get_settlement_transactions',
                  'can_get_settlement_metadata'
                ]"
              >
                <a
                  (click)="toggleTransactionsDropdown()"
                  class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                >
                  <img
                    src="assets/images/svgs/transfer-arrow--duotone.svg"
                    alt=""
                  />
                  Transactions

                  <img
                    [ngClass]="{
                      'rotate-180': transactionsMenuState === 'hidden',
                    }"
                    class="dropdown--toggle-icon rotate-180"
                    src="assets/images/svgs/chevron-up.svg"
                    alt=""
                  />
                </a>
              </li>

              <!-- START - Transactions dropdown menu items -->
              <div
                class="dropdown__wrapper"
                [ngClass]="
                  transactionsMenuState === 'visible' ? 'menu-open' : ''
                "
              >
                <div>
                  <li
                    *appHasPermission="[
                      'get_wallet_transaction',
                      'can_view_settlement_account_balance',
                      'get_optimus_account_balance',
                    ]"
                  >
                    <a
                      routerLink="/admin/transactions/wallet"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Wallet Transactions
                    </a>
                  </li>

                  <li
                    *appHasPermission="[
                      'can_get_global_portfolio_cash_balance',
                      'can_get_global_wallet_balance',
                      'can_view_cash_withdrawal_requests',
                    ]"
                  >
                    <a
                      routerLink="/admin/transactions/cash"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Cash To Wallet
                    </a>
                  </li>
                  <li
                    *appHasPermission="[
                      'can_view_global_principal',
                      'can_view_mutual_funds_list',
                      'can_get_all_funds_transaction',
                      'can_get_dividends',
                    ]"
                  >
                    <a
                      routerLink="/admin/transactions/mutual-funds"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Mutual Funds
                    </a>
                  </li>

                  <li
                    *appHasPermission="[
                      'can_get_fx_transactions',
                      'can_get_fx_transactions_metadata',
                    ]">
                    <a
                      routerLink="/admin/transactions/fx"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      FX Transactions
                    </a>
                  </li>

                  <li
                     *appHasPermission="['can_get_settlement_transactions', 'can_get_settlement_metadata']">
                    <a
                      routerLink="/admin/transactions/settlement"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Transaction Settlement
                    </a>
                  </li>

                  <li *appHasPermission="'can_get_wallet_withdrawal_requests'">
                    <a
                      routerLink="/admin/transactions/withdrawal-requests"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Withdrawal Requests
                    </a>
                  </li>
                </div>
              </div>
              <!-- END - Transactions dropdown menu items -->
              <!-- END - Transactions -->

              <!-- Start- Notifications -->
              <li>
                <a
                  (click)="toggleNotificationsDropdown()"
                  class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="size-6"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97ZM6.75 8.25a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H7.5Z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  Notifications

                  <img
                    [ngClass]="{
                      'rotate-180': notificationsMenuState === 'hidden',
                    }"
                    class="dropdown--toggle-icon rotate-180"
                    src="assets/images/svgs/chevron-up.svg"
                    alt=""
                  />
                </a>
              </li>

              <!-- START - Notification dropdown menu items -->
              <div
                class="dropdown__wrapper"
                [ngClass]="
                  notificationsMenuState === 'visible' ? 'menu-open' : ''
                "
              >
                <div>
                  <li>
                    <a
                      routerLink="/admin/push-notifications"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Push Notifications
                    </a>
                  </li>

                  <li>
                    <a
                      routerLink="/admin/notification-logs"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Notification Logs
                    </a>
                  </li>
                </div>
              </div>
              <!-- End: Notifications -->

              <li *appHasPermission="['get_all_configs']">
                <a
                  (click)="toggleSettingsDropdown()"
                  class="group flex cursor-pointer gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                >
                  <img src="assets/images/svgs/settings--duotone.svg" alt="" />
                  Settings
                  <img
                    [ngClass]="{
                      'rotate-180': settingsMenuState === 'hidden'
                    }"
                    class="dropdown--toggle-icon rotate-180"
                    src="assets/images/svgs/chevron-up.svg"
                    alt=""
                  />
                </a>
              </li>

              <!-- Settings dropdown menu items - desktop -->
              <div
                class="dropdown__wrapper"
                [ngClass]="
                  settingsMenuState === 'visible' ? 'menu-open' : ''
                "
              >
                <div>
                  <li *appHasPermission="['get_all_configs']">
                    <a
                      routerLink="/admin/settings/config"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Config
                    </a>
                  </li>
                  <li *appHasPermission="['get_all_configs']">
                    <a
                      routerLink="/admin/settings/bank"
                      routerLinkActive="bg-mango-lightOrange text-mango"
                      class="group flex gap-x-3 rounded-md p-2 pl-11 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50"
                    >
                      Bank Settings
                    </a>
                  </li>
                </div>
              </div>
            </ul>
          </li>

          <li class="mt-auto">
            <img
              class="dashboard-svg"
              src="assets/images/svgs/dashboard-side-illustration.svg"
              alt=""
            />
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <!-- END - Static sidebar for Desktop -->

  <div class="flex h-screen flex-col lg:pl-72">
    <div class="sticky top-0 z-40 lg:mt-4 lg:px-5">
      <div
        class="flex h-16 items-center gap-x-4 border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-0 lg:shadow-none"
      >
        <button
          type="button"
          (click)="toggleSidebarMenu()"
          class="-m-2.5 p-2.5 text-gray-700 lg:hidden"
        >
          <span class="sr-only">Open sidebar</span>
          <svg
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        </button>

        <!-- Separator -->
        <div class="h-6 w-px bg-gray-200 lg:hidden" aria-hidden="true"></div>

        <div
          class="flex flex-1 justify-end gap-x-4 self-stretch bg-mango-paleWhiteFC lg:gap-x-6"
        >
          <!-- Breadcrump -->
          <div class="hidden lg:relative lg:flex lg:flex-1 lg:items-center">
            <span
              class="cursor-pointer py-1 pl-0 pr-2 hover:text-mango"
              (click)="breadCrumbService.navigateToMain()"
            >
              {{ breadCrumbService.currentPage()?.main || 'Dashboard' }}
            </span>
            <span class="mx-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M5.83331 18.8333L14.1666 2.16666"
                  stroke="#D0D5DD"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span
              [ngClass]="
                !breadCrumbService.currentPage()?.primary
                  ? 'bg-mango-lightOrange text-mango'
                  : ''
              "
              class="cursor-pointer rounded-md px-2 py-1 hover:text-mango"
              (click)="breadCrumbService.navigateToNext()"
            >
              {{ breadCrumbService.currentPage()?.next || '..' }}
            </span>

            <span *ngIf="breadCrumbService.currentPage()?.primary" class="mx-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M5.83331 18.8333L14.1666 2.16666"
                  stroke="#D0D5DD"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span
              *ngIf="breadCrumbService.currentPage()?.primary"
              class="rounded-md bg-mango-lightOrange px-2 py-1 text-mango"
              (click)="breadCrumbService.navigateToPrimary()"
              >{{ breadCrumbService.currentPage()?.primary || '..' }}</span
            >
          </div>
          <div class="flex items-center gap-x-4 lg:gap-x-6">
            <!-- Notification bell -->
            <app-notification-bell></app-notification-bell>

            <!-- Profile dropdown -->
            <div class="relative">
              <button
                #toggleButton
                (click)="toggleNavigationMenu()"
                type="button"
                class="-m-1.5 flex items-center p-1.5 focus-visible:outline-mango"
                id="user-menu-button"
                aria-expanded="false"
                aria-haspopup="true"
              >
                <span class="sr-only">Open user menu</span>
                <span class="hidden lg:mr-5 lg:flex lg:flex-col">
                  <span>{{ userName }}</span>
                  <span>{{
                    userRoles.length > 1
                      ? userRoles[0].role.name + '+'
                      : userRoles[0].role.name
                  }}</span>
                </span>
                <img
                  class="h-8 w-8 rounded-full bg-gray-50"
                  src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                  alt=""
                />
                <span class="hidden lg:flex lg:items-center">
                  <svg
                    class="ml-2 h-5 w-5 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </span>
              </button>

              <div
                #menu
                [@dropdownMenuAnimation]="navigationMenuState"
                (@dropdownMenuAnimation.start)="popOverOpen($event)"
                [ngClass]="navigationMenuState === 'hidden' ? 'hidden' : ''"
                class="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu-button"
                tabindex="-1"
              >
                <!-- Active: "bg-gray-50", Not Active: "" -->
                <a
                  routerLink="/admin/my-profile"
                  class="block px-3 py-1 text-sm leading-6 text-gray-900 hover:bg-gray-50"
                  role="menuitem"
                  tabindex="-1"
                  id="user-menu-item-0"
                  >Your profile</a
                >
                <a
                  (click)="logout()"
                  class="block cursor-pointer px-3 py-1 text-sm leading-6 text-gray-900 hover:bg-gray-50"
                  role="menuitem"
                  tabindex="-1"
                  id="user-menu-item-1"
                  >Logout</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop Breadcrumb -->
    <main class="pb-10 pt-[0.94rem]">
      <div class="px-4 sm:px-6 lg:px-5">
        <!-- Your content -->
        <!-- Breadcrumb -->
        <nav
          aria-label="breadcrumb"
          class="relative mb-5 flex flex-1 items-center lg:hidden"
        >
          <span class="py-1 pl-0 pr-2">
            {{ mainBreadCrumb ? mainBreadCrumb : 'Dashboard' }}
          </span>
          <span class="mx-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M5.83331 18.8333L14.1666 2.16666"
                stroke="#D0D5DD"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span
            aria-current="page"
            class="rounded-md bg-mango-lightOrange px-2 py-1 text-mango"
            >{{ nextBreadCrumb }}</span
          >
        </nav>

        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>

<!-- Notification permission prompt -->
@if (showNotificationPrompt) {
  <div class="fixed bottom-6 right-6 z-[200] w-80 rounded-xl border border-gray-200 bg-white shadow-2xl">
    <div class="flex items-start justify-between p-4 pb-3">
      <div class="flex items-center gap-3">
        <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-mango-lightOrange">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-5 w-5 text-mango">
            <path fill-rule="evenodd" d="M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 1 1-7.48 0 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z" clip-rule="evenodd" />
          </svg>
        </div>
        <div>
          <p class="text-sm font-semibold text-gray-900">Enable Notifications</p>
          <p class="mt-0.5 text-xs text-gray-500">Stay updated on account activity and alerts.</p>
        </div>
      </div>
      <button type="button" (click)="dismissNotificationPrompt()" class="ml-2 flex-shrink-0 rounded p-0.5 text-gray-400 hover:text-gray-600">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-4 w-4">
          <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
        </svg>
      </button>
    </div>
    <div class="flex gap-2 border-t border-gray-100 px-4 py-3">
      <button
        type="button"
        mango-button
        variant="outline"
        (click)="dismissNotificationPrompt()"
        class="flex-1 items-center"
      >
        Not now
      </button>
      <button
        type="button"
        mango-button
        (click)="enableNotifications()"
        class="flex-1"
      >
        Enable
      </button>
    </div>
  </div>
}

<ng-template #confirmDialog></ng-template>
